import useLayout from "modules/preview/hooks/useLayout";

const useIsEmptyLayout = () => {
  const layout = useLayout();
  return layout === "empty";
};

export default useIsEmptyLayout;
